// extracted by mini-css-extract-plugin
export default {"card":"ScrollCard_card__MUoYT","item-detail-img":"ScrollCard_item-detail-img__45Jhf"};